import React from 'react';
import { GiRingedPlanet } from 'react-icons/gi';
import { Alert, Typography } from 'amphitheatre';

import { Card, TutText, TutorialTag } from '../Tutorials.styled';
import TutorialPage from '../TutorialPage';
import ImagePopup from '../../../ImagePopup';

import Pic1 from './pic1.png';
import Pic2 from './pic2.png';
import Pic3 from './pic3.png';
import Pic4 from './pic4.png';
import Pic5 from './pic5.png';
import Pic6 from './pic6.png';

const { Header, Paragraph } = Typography;

const Step3: React.FunctionComponent = () => {
  return (
    <TutorialPage nobg title="Tutorial #3: P.I.G.I. Ground Stations">
      <Card>
        <TutorialTag>
          <GiRingedPlanet />
          STEP 1
        </TutorialTag>
        <ImagePopup src={Pic1} alt="main menu" />
        <TutText>
          <Paragraph>
            Click the ‘Satcom’ button on the PIGI menu wheel.
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> STEP 2
        </TutorialTag>
        <ImagePopup src={Pic2} alt="controls" />
        <TutText>
          <Paragraph>
            This should bring up the ‘Add Ground Station’ module onto the
            screen.
          </Paragraph>
          <Paragraph>
            Change the parameters to your liking and name your ground station.
          </Paragraph>
        </TutText>
      </Card>
      <Header level={2} style={{ flexBasis: '100%', margin: '2rem 0' }}>
        Editing
      </Header>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> EDITING STEP 1
        </TutorialTag>
        <ImagePopup src={Pic3} alt="click planets" />
        <TutText>
          <Paragraph>
            Select your ground station to open up the details, if they do not
            appear, ensure your ground station is selected and click the blue
            ‘info’ button.
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> EDITING STEP 2
        </TutorialTag>
        <ImagePopup src={Pic4} alt="click earth" />
        <TutText>
          <Paragraph>
            Navigate to the settings tab, from there select ‘Edit Ground
            Station’ which will bring up a dialog box on the right
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> EDITING STEP 3
        </TutorialTag>
        <ImagePopup src={Pic5} alt="click earth" />
        <TutText>
          <Paragraph>
            To change the location of your ground station, edit the latitude and
            the longitude.
          </Paragraph>
          <Paragraph>
            <Alert primary>
              Note: the map on the bottom right corner of your screen can
              provide approximate GPS coordinates.
            </Alert>
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> EDITING STEP 4
        </TutorialTag>
        <ImagePopup src={Pic6} alt="click earth" />
        <TutText>
          <Paragraph>
            You are also able to visualise your field of view by checking the
            ‘FOV enable’ which will allow you to better edit the angle and size
            of the FOV cone.
          </Paragraph>
        </TutText>
      </Card>
    </TutorialPage>
  );
};

export default Step3;
